import XlsxUploadCard from "./XlsxUploadCard";

/**
 * Inventario (SDM/Yamaha stock) upload card. Thin wrapper over the generic
 * XlsxUploadCard configured for /admin/inventory/upload-xlsx.
 *
 * Data source: the Inventario XLSX exported from SAP (sheet "Export").
 * Each row is a chassis (VIN). The Forecast module uses this to estimate
 * "puedo vender lo pronosticado" cross-checking stock vs expected sales.
 */
export default function InventoryUploadCard({ onUploaded }) {
  return (
    <XlsxUploadCard
      kind="inventory"
      endpoint="/admin/inventory/upload-xlsx"
      title="Inventario Disponible"
      description={<>Sube el archivo <strong>Inventario.xlsx</strong> (sheet &quot;Export&quot;). Cada fila representa una unidad identificada por <code>Chasis</code>. Estado &quot;Disponible&quot; = stock libre para venta.</>}
      resultKeys={{
        insertedLabel: "Nuevas",
        updatedLabel: "Actualizadas",
        totalKey: "total_inventory_after",
        totalLabel: "Total en inventario",
      }}
      testid="inventory-upload-card"
      showModeSelector
      defaultMode="append"
      onUploaded={onUploaded}
    />
  );
}
